import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import { getAvatarStyle } from '../../lib/s3';
import moment from 'moment';
import { get } from 'lodash';

const useStyles = makeStyles(theme => ({
  inline       : {
    display : 'inline',
  },
  readColumn   : {
    width     : 40,
    marginTop : 30,
    fontSize  : 8,
  },
  callToAction : { float: 'right' },
  time         : {
    position : 'absolute',
    bottom   : 20,
  },
}));

export const PartialSaleInterestNotification = props => {
  const { notification } = props;
  const classes = useStyles();
  const profile_picture = get(notification, 'actor.profile_picture');
  const actorName = get(notification, 'actor.allowed_name', '');
  const partialSaleDetails = get(notification, 'notifiable.partial_sale_listing.segment_details', '');
  
  return (
    <ListItem alignItems="flex-start">
      <ListItemText>
        {!get(notification, 'readAt') ? (
          <div className={classes.readColumn}>&#128313;</div>
        ) : (
          <div className={classes.readColumn}>&nbsp;</div>
        )}
      </ListItemText>
      <ListItemAvatar>
        <Avatar name={get(notification, 'notifiableType')} src={profile_picture ? getAvatarStyle(profile_picture).url : null} />
      </ListItemAvatar>
      <ListItemText
        primary={
          <Fragment>
            <b>{actorName}</b> has expressed interest in your partial sale listing "{partialSaleDetails}".
          </Fragment>
        }
        secondary={
          <Fragment>
            <span className={classes.time}>{get(notification, 'createdAt') && moment(notification.createdAt).fromNow()}</span>
            <br></br>
            <Button
              href={`/users/${get(notification, 'recipient.user_name', '')}/partial_sales`}
              className={classes.callToAction}>
              <FormattedMessage id="notifications.view_partial_sales" defaultMessage="View Partial Sales" />
            </Button>
          </Fragment>
        }
      />
    </ListItem>
  );
};

PartialSaleInterestNotification.propTypes = {
  notification : PropTypes.object,
};

PartialSaleInterestNotification.defaultProps = {
  notification : {},
};

export default PartialSaleInterestNotification;
